import { usePortfolioRemindersListQuery } from "web_myplann/Api/Reminders/usePortfolioRemindersListQuery";
import { RemindersSectionView } from "web_myplann/Reminders/Components/RemindersSectionView";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
};

export const PortfolioRemindersSectionContent = ({ entity }: Props) => {
	const { data, isLoading, isError } = usePortfolioRemindersListQuery(
		entity.id,
	);

	return (
		<RemindersSectionView
			entity={entity}
			reminders={data}
			isLoading={isLoading}
			isError={isError}
		/>
	);
};
